
import React from 'react';
import { ChatMessage } from '@/types/chat';
import { Copy, MoreHorizontal } from 'lucide-react';
import { toast } from 'sonner';

interface UserMessageActionsProps {
  message: ChatMessage;
}

const UserMessageActions: React.FC<UserMessageActionsProps> = ({ message }) => {
  const handleCopyMessage = React.useCallback(() => {
    navigator.clipboard.writeText(message.content);
    toast.success('Message copied to clipboard');
  }, [message.content]);

  return (
    <div className="user-message-actions">
      <button
        className="action-button"
        onClick={handleCopyMessage}
        aria-label="Copy message"
      >
        <Copy size={14} />
      </button>
      <button
        className="action-button"
        aria-label="More options"
      >
        <MoreHorizontal size={14} />
      </button>
    </div>
  );
};

export default UserMessageActions;
